export function apiErrorData(error: unknown): Record<string, unknown> | undefined {
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as { response?: { data?: unknown } }).response
    const data = response?.data
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      return data as Record<string, unknown>
    }
  }
  return undefined
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message) {
    return error.message
  }
  return fallback
}

interface HttpFailure {
  code?: string
  response?: { status?: number }
}

/**
 * Человекочитаемая причина сбоя запроса, когда сервер не прислал свой текст:
 * обрыв сети, таймаут, 413 и ошибки шлюза (axios отдаёт для них «Network Error»
 * или «Request failed with status code 502»). Для остальных случаев возвращает null.
 */
export function friendlyHttpMessage(error: unknown): string | null {
  const failure = error as HttpFailure | null
  if (!failure || typeof failure !== 'object') return null

  const status = failure.response?.status
  if (status === undefined) {
    if (failure.code === 'ECONNABORTED' || failure.code === 'ETIMEDOUT') {
      return 'Сервер долго не отвечает. Повторите попытку'
    }
    if (failure.code === 'ERR_NETWORK') {
      return 'Нет соединения с сервером. Проверьте подключение и повторите попытку'
    }
    return null
  }

  if (status === 413) return 'Файл слишком большой для загрузки'
  if (status === 429) return 'Слишком много запросов. Подождите минуту и повторите'
  if (status === 502 || status === 503 || status === 504) {
    return 'Сервис временно недоступен. Повторите попытку через минуту'
  }
  return null
}
